import { useTranslation } from 'react-i18next';

/**
 * P3. Rendered while a signed-in feature chunk streams in (route-level
 * code-splitting). Unlike `FullPageSpinner` it never claims the whole
 * viewport: it sits inside AppShell's content area, so the tab bar stays
 * visible and tappable while the page loads.
 */
export function RouteFallback(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="py-24 flex items-center justify-center" role="status">
      <span className="h-8 w-8 animate-spin rounded-full border-2 border-outline-variant border-t-primary" />
      <span className="sr-only">{t('common.loading')}</span>
    </div>
  );
}
